import styled from 'styled-components';

export const FormWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 32px;
  border-radius: 12px;
  box-shadow: 0px 0px 65px rgba(145, 145, 145, 0.12);
  margin-top: 20px;

  .ant-form-item {
    width: 288px;
  }

  form {
    & > div:last-child {
      .ant-btn {
        & > div {
          margin-left: 7px;
        }
      }
    }
  }

  @media only screen and (max-width: 480px) {
    padding: 32px 20px;
  }
`;
